export function getStableNow() {
  const now = new Date();
  now.setMilliseconds(0);
  now.setMinutes(0);
  now.setHours(0);
  return now;
}
